module.exports = __webpack_public_path__ + "static/media/c-sharp-beginner.f7b488db.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/c-sharp-beginner.png
// module id = 1452
// module chunks = 146